import { render, staticRenderFns } from "./SharePaymentLinkModal.vue?vue&type=template&id=5bd4453d&scoped=true"
import script from "./SharePaymentLinkModal.vue?vue&type=script&lang=js"
export * from "./SharePaymentLinkModal.vue?vue&type=script&lang=js"
import style0 from "./SharePaymentLinkModal.vue?vue&type=style&index=0&id=5bd4453d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd4453d",
  null
  
)

export default component.exports